import { gql } from "@apollo/client";

export const IS_SUPPORTED_VERSION = gql`
  query isSupportedVersion($version: String!) {
    isSupportedVersion(version: $version)
  }
`;

export const FEATURE_FLAGS = gql`
  query featureFlags {
    featureFlags {
      name
      value
    }
  }
`;
